module.exports = __webpack_public_path__ + "static/media/divya-desktop.57cc3350.jpg";